import {
  BaseUserCustomProperties,
  ServerUser,
  ServerUserUpdated,
  UpdatedUser,
  User,
} from "./types";

const defaultCustomProperties: BaseUserCustomProperties = {
  "has-completed-onboarding": false,
};

function resolveCustomProperties<P extends BaseUserCustomProperties>(
  raw: Record<string, any> | null | undefined,
): P {
  return {
    ...defaultCustomProperties,
    ...raw,
  } as P;
}

export function resolveUser<
  P extends BaseUserCustomProperties = BaseUserCustomProperties,
>(user: ServerUser): User<P> {
  return {
    ...user,
    custom_properties: resolveCustomProperties<P>(user.custom_properties),
  };
}

export function resolveUpdatedUser<
  P extends BaseUserCustomProperties = BaseUserCustomProperties,
>(user: ServerUserUpdated): UpdatedUser<P> {
  return {
    ...user,
    custom_properties: resolveCustomProperties<P>(user.custom_properties),
  };
}
